export enum FilterType {
  Date = 'date',
  Select = 'select',
  SelectCategory = 'selectCategory',
}

export enum CustomFiltersFields {
  Field = 'field',
}
